import { combineReducers } from "@reduxjs/toolkit";
import { connectRouter } from "connected-react-router";
import { createBrowserHistory } from "history";

import quoteReducer from "../store/QuoteSlice";
import quotesReducer from "../store/QuotesSlice";
import deductionsReducer from "../store/DeductionsSlice";
import accountReducer from "../store/AccountSlice";
import redirectReducer from "../store/RedirectSlice";
import templateReducer from "../store/TemplateSlice";
import productSubscriptionReducer from "../store/ProductSubscriptionSlice";
import productSpecSheetReducer from "../store/ProductSpecSheetSlice";
import checkoutReducer from "../store/checkoutPage.slide";

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href") as string;
export const history = createBrowserHistory({ basename: baseUrl });

const rootReducer = combineReducers({
  router: connectRouter(history),
  quote: quoteReducer,
  quotes: quotesReducer,
  deductions: deductionsReducer,
  account: accountReducer,
  redirect: redirectReducer,
  template: templateReducer,
  subscriptions: productSubscriptionReducer,
  checkout: checkoutReducer,
  specSheets: productSpecSheetReducer
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
